import React from 'react'

import * as sharedStyles from 'common/builder/components/chart/FlowChart/nodes/shared/styles'

export const wrapper: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  alignSelf: 'stretch',
  flexDirection: 'row',
  flexGrow: 1,
}

export const textContainer: React.CSSProperties = {
  flexGrow: 2,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  overflow: 'hidden',
}

export const textStyle: React.CSSProperties = {
  ...sharedStyles.subheading,
  ...sharedStyles.textPrimary,
  ...sharedStyles.textEllipsis,
  flexGrow: 1,
  textAlign: 'left',
}

export const textStyleHover: React.CSSProperties = {
  ...textStyle,
  textDecoration: 'underline',
}
